import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'
//import * as IoIcons from 'react-icons/io'
export const SidebarData = [
    {
        title: 'Email Setup',
        path: '/home',
        icon: <AiIcons.AiFillMail/>,
        cName: 'nav-text'
    },
    {
        title: 'Venues',
        path: '/venues',
        icon: <FaIcons.FaBuilding />,
        cName: 'nav-text'
    },
    {
        title: 'Artist Roster',
        path: '/clients',
        icon: <FaIcons.FaUser />,
        cName: 'nav-text'
    },
    {
        title: 'Documents',
        path: '/documents',
        icon: <AiIcons.AiFillFileText />,
        cName: 'nav-text'
    }, 
    {
        title: 'Update Form',
        path: '/update-form',
        icon: <FaIcons.FaEdit />,
        cName: 'nav-text'
    },    
];
